module.exports = __webpack_public_path__ + "media/vid_phone_case1.cfecb982.mp4";